import Vue from 'vue';
import { component } from '../../decorators';

import { isIE } from '../../helpers/isIE';

const STYLE = `
   display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%;
   overflow: hidden; pointer-events: none; z-index: -1; opacity: 0;
`;

@component
export default class ResizeObserverComponent extends Vue {
   _resizeObject = null
   // $FlowFixMe
   _observer = null
   _w = null
   _h = null

   notify() {
      this.$emit('notify');
      const { offsetWidth, offsetHeight } = this.$el;
      if (this._w !== offsetWidth) {
         this.$emit('width');
      }
      if (this._h !== offsetHeight) {
         this.$emit('height');
      }
      this._h = offsetHeight;
      this._w = offsetWidth;
   }

   addResizeHandlers() {
      // $FlowFixMe
      this._resizeObject.contentDocument.defaultView.addEventListener('resize', this.notify);
      if (this._w !== this.$el.offsetWidth || this._h !== this.$el.offsetHeight) {
         this.notify();
      }
   }

   removeResizeHandlers() {
      if (this._resizeObject && this._resizeObject.onload) {
         // $FlowFixMe
         if (!isIE && this._resizeObject.contentDocument) {
            // $FlowFixMe
            this._resizeObject.contentDocument.defaultView.removeEventListener('resize', this.notify);
         }
         delete this._resizeObject.onload;
      }
   }

   polyfill() {
      this.$nextTick(() => {
         this._w = this.$el.offsetWidth;
         this._h = this.$el.offsetHeight;
      });
      const object = document.createElement('object');
      this._resizeObject = object;
      object.setAttribute('style', STYLE);
      object.setAttribute('aria-hidden', 'true');
      object.setAttribute('tabindex', '-1');
      object.onload = this.addResizeHandlers;
      object.type = 'text/html';
      if (isIE) {
         this.$el.appendChild(object);
      }
      object.data = 'about:blank';
      if (!isIE) {
         this.$el.appendChild(object);
      }
   }

   mounted() {
      if ('ResizeObserver' in window) {
         this._observer = new ResizeObserver(this.notify);
         this._observer.observe(this.$el);
      } else {
         this.polyfill();
      }
   }

   beforeDestroy() {
      if (this._observer) {
         this._observer.disconnect();
      }
      this.removeResizeHandlers();
   }
}
